import styled from 'styled-components';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100vh;

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.greyLight};
  }

  button {
    border: none;
    background: none;
    color: ${({ theme }) => theme.colors.blue};
    margin-top: 32px;
    
    font-size: 26px;
    font-weight: bold;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 30%;

  img {
    height: unset;
  }
`;

export const Styled = {
  PageWrapper,
  ImageWrapper,
};
